import type { IAnimatedLaptopProps } from './AnimatedLaptop';

async function MountAnimatedLaptop(props: IAnimatedLaptopProps, el: Element) {
	const a = await import('./AnimatedLaptop');
	a.MountAnimatedLaptop(props, el);
}

(window as any).MountAnimatedLaptop = MountAnimatedLaptop;
